import { AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { ApiResult } from 'src/Libs/api'
import { GoogleMapsGeocodeResponse, UserLocationData } from '../types/location.types'
import { getLocationDetails } from '../utils'

export const getAddress = async (lat: number, lng: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<UserLocationData | null>> => {
  const apiKey = process.env.REACT_APP_MAPS_TOKEN
  const addressUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`

  try {
    const response = await authFetch<GoogleMapsGeocodeResponse>({
      endpoint: addressUrl,
      path: '',
    }).then(res => res.data)

    if (!response.results?.length) return new ApiResult(null)

    const details = response.results
      .map(result => getLocationDetails(result.address_components, result.geometry))
      .sort((resultA, resultB) => getAddressCompletenessLevel(resultB) - getAddressCompletenessLevel(resultA))

    return new ApiResult<UserLocationData | null>(details[0])
  } catch (error) {
    console.error('Failed to fetch address:', error)
    throw new ApiResult(null)
  }
}

/** Returns the number of fields that have non-empty values. */
const getAddressCompletenessLevel = (data: UserLocationData): number => {
  const { city, countryCode, houseNumber, postalCode, street } = data
  return (
    Number(Boolean(city.trim())) +
    Number(Boolean(countryCode)) +
    Number(Boolean(houseNumber.trim())) +
    Number(Boolean(postalCode.trim())) +
    Number(Boolean(street.trim()))
  )
}
